export default "__VITE_ASSET__Bfkp$0Or__"